/**
 * Platform-aware label for the assistant dock shortcut (Cmd/Ctrl + G,
 * "G for Gail"), mirroring how the nav search advertises "⌘K".
 *
 * Only call this from the client after mount (via `useAssistantShortcutHint`).
 * Calling during SSR / first paint with a platform-specific return would
 * hydrate-mismatch on non-Apple devices (server used to default to `⌘G`).
 */
export const getAssistantShortcutHint = (): string => {
  const isApple = /Mac|iPhone|iPad|iPod/i.test(
    globalThis.window?.navigator?.userAgent ?? ""
  );
  return isApple ? "⌘G" : "Ctrl+G";
};
